export default __webpack_public_path__ + "locales/bg/Common.json?hash=144f2924f99391c4260e0f42787db53d";